//-------------------------------------------------------------------------------------------
// IMPORTANT:
//  - The pre-built behavior to target separate error messages (ie. one for required and
//    one for a pattern), doesn't appear to be working (it does on the website).
//  - data-form-error-for was tried
//  - separating required and pattern="email" was tried
//  - The default code always seems to apply is-visible to all .form-error elements and thuse
//    never shows one error message.
//  - The code below adds a .is-hidden class to force the form-error to hide.  This occurs
//    even though both is-hidden and is-visible classes both exist as is-hidden takes priority.
//    Both classes use !important so inline display: none style also doesn't work.
//
// Description
//  - This custom abide validation function is designed to check email and phone for pattern and entry (required)
//    and display one of two error message based on the class.
//-------------------------------------------------------------------------------------------
import { PatternValidator } from './pattern-validator';

Foundation.Abide.defaults.validators['validate_field_type'] = validateFieldType;

function validateFieldType(
    $el,      /* jQuery element to validate */
    required, /* is the element required according to the `[required]` attribute */
    parent    /* parent of the jQuery element `$el` */
) {
    var validator = PatternValidator();

    var type = $el.attr('data-validation-type');
    var value = $el.val();

    if (type && type.toLowerCase() == "drop-down-selection-required") {
        if (!value || value.length == 0) {
            $el.addClass("invalid-required");
            showFormErrorChildren(parent, "invalid-required");
            $el.attr("aria-invalid", "true");
            return false;
        }
    }
    else if (value && value.length && type) {
        switch (type.toLowerCase()) {
            case "phone":
                if (!validator.isValidPhone(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "email":
                if (!validator.isValidEmail(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "address":
                if (!validator.isValidAddress(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "city":
                if (!validator.isValidCity(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "state":
                if (!validator.isValidState(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "zipcode": // preferred
            case "us-zipcode":
                if (!validator.isValidZipCode(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "postalcode": // for canadian postal codes
            case "canadian-postalcode":
                if (!validator.isValidPostalCode(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "us-ca-postalcode":
                if (!validator.isValidZipOrPostalCode(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "us-or-ca-postalcode":
                var stateDropdown = $("#" + $el.data("state-dropdown-id"));
                var selectedIndex = stateDropdown.prop('selectedIndex');
                var isValid = true;
                // If selected Index is > than Canada Index then use isValidPostalCode Else if US use isValidZipCode
                // Canada index = 60
                if (selectedIndex > 60) {
                    isValid = validator.isValidPostalCode(value)
                }
                else {
                    isValid = validator.isValidZipCode(value)
                }

                // If not Valid show errors
                if (!isValid) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "firstname":
                if (!validator.isValidFirstName(value) ||
                    (validator.isOnlySpaces(value) && $el.attr('required') != 'required')) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "middlename":
                if (!validator.isValidMiddleName(value) ||
                    (validator.isOnlySpaces(value) && $el.attr('required') != 'required')) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "lastname":
                if (!validator.isValidLastName(value) ||
                    (validator.isOnlySpaces(value) && $el.attr('required') != 'required')) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            case "xss":
                // validate for cross site scripting (XSS)
                if (validator.isXSS(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "communityname":
                if (!validator.isValidCommunityName(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;

            case "visitdate":
                if (!validator.isValidVisitDate(value)) {
                    // shows only form-error elements (under the parent) with .invalid-pattern
                    $el.removeClass("invalid-required");
                    $el.addClass("invalid-pattern");
                    showFormErrorChildren(parent, "invalid-pattern");
                    $el.attr("aria-invalid", "true");
                    return false;
                }
                break;
            default:
                break;
        };
    }

    // if the type validation passes and there's a required flag - check for a value
    if ($el.attr('required') == 'required' && (!value || value.length == 0 || validator.isOnlySpaces(value))) {
        $el.addClass("invalid-required");
        $el.removeClass("invalid-pattern");
        showFormErrorChildren(parent, "invalid-required");
        $el.attr("aria-invalid", "false");
        return false;
    }

    // clears all form-error elements (under the parent)
    $el.removeClass("invalid-required");
    $el.removeClass("invalid-pattern");
    $el.attr("aria-invalid", "false");
    showFormErrorChildren(parent, "");
    return true;
};

function showFormErrorChildren($parent, className) {
    var children = $parent.children(".form-error");
    if (children.length) {
        for (var i = 0; i < children.length; i++) {
            if (children[i].classList.contains(className)) {
                children[i].classList.remove("is-hidden");
            } else {
                children[i].classList.add("is-hidden");
            }
        }
    }
}
